/** Represent the lca impact of an activity (travels, building). */
export class ImpactIntensity {
  /**
   *
   * Create a new ImpactIntensity
   *
   * @param {Dict} intensity
   *
   */
  constructor (intensity = {}) {
    this.intensity = intensity
  }

  get isEmpty () {
    return Object.keys(this.intensity).length === 0
  }

  hasKey (key) {
    if (this.isEmpty) {
      return false
    } else {
      return Object.keys(this.intensity).includes(key)
    }
  }

  multiply (mfactor) {
    let is = {}
    for (let key of Object.keys(this.intensity)) {
      is[key] = mfactor * this.intensity[key]
    }
    return new ImpactIntensity(is)
  }

  divide (dfactor) {
    let is = {}
    for (let key of Object.keys(this.intensity)) {
      is[key] = this.intensity[key] / dfactor
    }
    return new ImpactIntensity(is)
  }

  getImpactKeys () {
    return Object.keys(this.intensity)
  }

  static compute (value, factor) {
    let intensity = {}
    let f = factor.getFactor()
    for (let key of Object.keys(f)) {
      intensity[key] = value * f[key]
    }
    return new ImpactIntensity(intensity)
  }

  /**
   * Create from another object (typically from the database)
   *
   * @param {*} intensity
   */
  static createFromObj (intensity) {
    return new ImpactIntensity(intensity)
  }
}

/** Collection of ImpactIntensity.
 *
 */
export class ImpactIntensities {
  /**
   * Create and initialize the collection.
   */
  constructor (keys = []) {
    this._intensities = []
    // set default keys if provided
    this._keys = keys
  }

  add (intensity) {
    if (intensity instanceof ImpactIntensity) {
      this._intensities.push(intensity)
    } else if (intensity instanceof ImpactIntensities) {
      this._intensities.push(...intensity._intensities)
    }
  }

  sum () {
    let sum = {}
    if (this._intensities.length === 0) {
      for (let k of this._keys) {
        sum[k] = 0
      }
    }
    for (let cintensity of this._intensities) {
      for (let fkey of cintensity.getImpactKeys()) {
        if (Object.keys(sum).includes(fkey)) {
          sum[fkey] += cintensity.intensity[fkey]
        } else {
          sum[fkey] = cintensity.intensity[fkey]
        }
      }
    }
    return new ImpactIntensity(sum)
  }
}
